import { Tooltip } from '@pmi/dsm-react';
import { TableCellProps } from '../models';
import styles from './assignedProductCell.module.scss';
import RenderHtml from '../../../../../../shared/components/RenderHtml';

export default function AssignedProductCell({
  row,
  productsNames,
}: TableCellProps) {
  const renderAssignedProducts = () => {
    if (productsNames?.length > 0) {
      return productsNames.map((n, i) => (
        <Tooltip
          content={
            <RenderHtml html={n.name} tag="span" className="fw-normal" />
          }
          type="sm"
          blockTriggers={n.name.length < 35}
          placement="top"
          className="darkTooltip"
          key={`tooltipProduct${row.original.personId}${
            row.original.personId
          }${(Math.random() + 1).toString(36).substring(7)}`}
        >
          <RenderHtml
            html={n.name}
            tag="span"
            className={`${styles.assignedProduct} mb-1`}
            key={`products${row.original.personId}-item-${i + 1}`}
          />
        </Tooltip>
      ));
    }
    return (
      <span
        className={`${styles.assignedProduct} mb-1`}
        key={`products${row.original.personId}${row.original.personId}${(
          Math.random() + 1
        )
          .toString(36)
          .substring(7)}`}
      >
        N/A
      </span>
    );
  };

  return (
    <span
      className={styles.prodGroupCell}
      key={`assignedProducts-${row.original.personId}${(Math.random() + 1)
        .toString(36)
        .substring(7)}`}
    >
      {renderAssignedProducts()}
    </span>
  );
}
